const montarSugestao = (email, resultado, input) => {
  let sugestao = email + "@" + resultado
  let sugestoesDiv = $("<div>").attr("class", "sugestoes-block");
  
  let sugestaoItem = $("<div>").attr("data-sugestao", sugestao).html(I18n.t("sugestao", {email: email, dominio: resultado}));
  
  sugestaoItem.on("click", () => {
    $(input).val(sugestaoItem.data('sugestao'))
    limparSugestoesEmails(input)
  });
  
  sugestoesDiv.append(sugestaoItem);
  $(input).parent().append(sugestoesDiv)
}

const limparSugestoesEmails = (input) => {
  $(input).parent().find('.sugestoes-block').remove()
}

export {
  montarSugestao,
  limparSugestoesEmails
}